import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class ModelParsingTaskService {
  // 分页查询模型解析任务
  static async getModelParsingTaskList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ModelParsingTask/paged-result?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增模型解析任务
  static async addModelParsingTask(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ModelParsingTask/create', payload)
    )
    return Callback(err, res)
  }
  // 编辑模型解析任务
  static async updateModelParsingTask(payload) {
    const [err, res] = await To(
      wizStandardInstance.put('/api/std/ModelParsingTask/update', payload)
    )
    return Callback(err, res)
  }
  // 删除模型解析任务
  static async deleteModelParsingTask(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/ModelParsingTask', { data: payload })
    )
    return Callback(err, res)
  }
  // 分页查询模型关联关系
  static async getModelObjectRelationList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ModelObjectRelation/paged-result?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增模型关联关系
  static async addModelObjectRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ModelObjectRelation/create', payload)
    )
    return Callback(err, res)
  }
  // 删除模型关联关系
  static async deleteModelObjectRelation(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/ModelObjectRelation', { data: payload })
    )
    return Callback(err, res)
  }
  // 查询属性值
  static async getAttributeValuesList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/attribute-values?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 手动执行解析任务
  static async manualExecution(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ModelParsingTask/rerun/${payload}`)
    )
    return Callback(err, res)
  }
  // 模型解析进度
  static async getModelParseProgress(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/ModelParsingTask/latest-run-record?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 删除解析进度
  static async deleteRunRecord(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/ModelParsingTask/delete-run-record', { data: payload })
    )
    return Callback(err, res)
  }
}
